import styled, { DefaultTheme } from 'styled-components';

import { media } from '~src/styles/media-templates';

const filtersOnANewRowMQWidth = '1560px';
const tightFilterRowMQ = '910px';

export const FiltersContainer = styled.div`
  min-height: 95px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 20px ${({ theme }) => theme.sz.pageSidePadding} 0;
  ${media.desktop`
    padding: 20px ${({ theme }) => (theme as DefaultTheme).sz.pageSidePaddingS} 0;
  `};
  @media (max-width: ${filtersOnANewRowMQWidth}) {
    flex-direction: column;
  }
`;

export const CoreFiltersBlock = styled.div`
  margin: 0 30px 15px 0;
  display: flex;
  flex-wrap: nowrap;
`;

export const SearchWrapper = styled.div`
  width: 200px;
`;

export const FilterBtnTxt = styled.div`
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  padding-left: 5px;
  white-space: nowrap;
`;

export const MyObjectivesBtn = styled.div<{ $isSessionUserObj: boolean }>`
  display: flex;
  margin-left: 60px;
  align-items: center;
  color: ${({ theme }) => theme.baseBlue.a6};
  &:hover {
    cursor: pointer;
    ${FilterBtnTxt} {
      color: ${({ theme }) => theme.baseBlue.a10};
    }
  }

  ${FilterBtnTxt} {
    ${({ theme, $isSessionUserObj }) => ($isSessionUserObj ? `color: ${theme.baseBlue.a10}` : '')};
  }
  @media (max-width: 1590px) {
    margin-left: 30px;
  }
`;

export const ToggleButton = styled.div<{ $state: boolean }>`
  cursor: pointer;
  color: ${({ theme, $state }) => ($state ? theme.baseBlue.a10 : theme.baseBlue.a6)};
  &:hover {
    ${({ theme }) => `color: ${theme.baseBlue.a10}`};
  }
`;

export const FiltersSetContainer = styled.div`
  display: flex;
  min-height: 30px;
`;

export const CollapsibleContainer = styled.div<{ $timeout: number }>`
  min-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  max-width: 100%;

  @media (max-width: ${filtersOnANewRowMQWidth}) {
    border-right: 1px solid ${({ theme }) => theme.black.a1};
  }
  @media (max-width: 595px) {
    width: calc(100vw - 165px);
    overflow-x: auto;
  }
`;

export const SelectorCol = styled.div`
  margin-right: 30px;
  @media (max-width: ${tightFilterRowMQ}) {
    margin-right: 15px;
  }
  .inactive {
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }

`;

export const ResetFiltersBtn = styled.button`
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.baseBlue.a6};
  padding: 0 0 0 30px;
  white-space: nowrap;
  background: transparent;
  border: 0;
  border-left: 1px solid ${({ theme }) => theme.black.a1};
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }

  @media (max-width: ${filtersOnANewRowMQWidth}) {
    border-left: 0;
  }
  @media (max-width: ${tightFilterRowMQ}) {
    padding-left: 15px;
  }

  > div {
    margin-right: 5px;
    display: block;
  }
`;
